import * as React from "react";
import { message } from "antd";


export default class LoaderUtility {

    private static count: number = 0;
    private static hider: any;


    public static show() {
        ++LoaderUtility.count;

        if (LoaderUtility.count && !LoaderUtility.hider) {
            // hider was not set so nothing is been shown
            LoaderUtility.hider = message.loading('', 0);
        }
    }

    public static hide() {

        LoaderUtility.count--;

        if (LoaderUtility.count <= 0 && LoaderUtility.hider) {
            LoaderUtility.hider();
            LoaderUtility.hider = undefined;
        }
    }


    public static reset() {
        LoaderUtility.count = 0;
        if (LoaderUtility.hider) {
            LoaderUtility.hider();
        }
        LoaderUtility.hider = undefined;
    }

}
